import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	AddAppVisitNoteStatus,
	AddAppVisitNoteStatusEvent,
} from '../add-device-note-main-tab.component';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-add-device-note-confirmation',
	templateUrl: './add-device-note-confirmation.component.html',
	styleUrls: [
		'./add-device-note-confirmation.component.scss',
		'../../../ui/common/main.scss',
	],
	imports: [
		MatDivider,
		MatProgressSpinner,
		MatGridList,
		MatGridTile,
		MatButton,
	],
})
export class AddDeviceNoteConfirmationComponent implements OnInit {
	@Input() deviceId?: string;
	@Input() deviceSN?: string;
	@Input() addAppVisitNoteStatusEvents!: Observable<AddAppVisitNoteStatusEvent>;
	showLoading = false;
	showSuccess = false;
	showFailure = false;

	note = '';
	fileDetails: {
		file: File;
		previewURL: string | ArrayBuffer | null;
		caption: string;
	}[] = [];
	constructor(private readonly router: Router) {}

	ngOnInit(): void {
		this.addAppVisitNoteStatusEvents.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			this.note = event?.data?.note ?? '';
			this.fileDetails = event?.data?.photo ?? [];

			switch (event.status) {
				case AddAppVisitNoteStatus.loading:
					this.showLoading = true;
					break;
				case AddAppVisitNoteStatus.success:
					this.showSuccess = true;
					break;
				case AddAppVisitNoteStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	onAddNoteClicked(): void {
		this.router.navigate(['/add-note'], {
			queryParams: { deviceId: this.deviceId },
		});
	}

	onDeviceNotesClicked(): void {
		this.router.navigate(['/devices/' + this.deviceId], {
			queryParams: { tabIndex: 2 },
		});
	}
}
